<div class="modal-header">
  <div class="modal-title">
      <h3>{{title}}</h3>
  </div>
  @if(closeAvailable) {
      <button type="button" class="close" (click)="close()" aria-label="Close">
          <i title="Stäng" class="fa-regular fa-xmark mr-2"></i>
      </button>
  }
</div>
<div class="modal-body">
  <div class="text-center">
      {{description}}
  </div>
</div>

<div class="modal-footer">
  @if(acceptBtnTitle) {
      <button class="btn btn-primary" (click)="accept()">{{acceptBtnTitle}}</button>
  }
  @if(abortBtnTitle) {
      <button class="btn btn-warning" (click)="abort()">{{abortBtnTitle}}</button>
  }
</div>
